import { useLocation, useNavigate } from "react-router-dom";
import menuBurguerWhite from "../../../assets/svgs/icons/bars-icon-white.svg";
import menuBurguerBlue from "../../../assets/svgs/icons/bars-icon.svg";
import instagramBlue from "../../../assets/svgs/icons/instagram-blue.svg";
import instagramWhite from "../../../assets/svgs/icons/instagram-white.svg";
import linkedinBlue from "../../../assets/svgs/icons/linkedin-blue.svg";
import linkedinWhite from "../../../assets/svgs/icons/linkedin-white.svg";
import planetWhite from "../../../assets/svgs/icons/planet-white.svg";
import planetBlue from "../../../assets/svgs/icons/planet.svg";
import xTimesWhite from "../../../assets/svgs/icons/x-times-white.svg";
import xTimesBlue from "../../../assets/svgs/icons/x-times.svg";
import youtubeBlue from "../../../assets/svgs/icons/youtube-blue.svg";
import youtubeWhite from "../../../assets/svgs/icons/youtube-white.svg";
import logoTelemontWhite from "../../../assets/svgs/telemont-logo-white.svg";
import logoTelemontBlue from "../../../assets/svgs/telemont-logo.svg";
import { redirectToMedia } from "../../../utils/redirectToMedia";
import TextButton from "../../buttons/text-button";
import DefaultText from "../../typography/default-text";
import styles from "./styles.module.css";
import { sxButtonMobileMenu, sxTextMenu } from "./sxProps";
const MobileMenu: React.FC<{ open: boolean, switchOpenMenu: () => void }> = ({ open, switchOpenMenu }) => {

  const pageLocation = useLocation();
  const navigate = useNavigate();
  const isHome = pageLocation.pathname === "/";
  const planet = isHome ? planetBlue : planetWhite;
  const logoTelemont = isHome ? logoTelemontBlue : logoTelemontWhite;
  const menuBurguer = isHome ? menuBurguerBlue : menuBurguerWhite;
  const xTimes = isHome ? xTimesBlue : xTimesWhite;
  const youtube = isHome ? youtubeBlue : youtubeWhite;
  const instagram = isHome ? instagramBlue : instagramWhite;
  const linkedin = isHome ? linkedinBlue : linkedinWhite;

  return (
    <header>
      <nav style={open ? { height: "100vh", zIndex: 99 } : {}}>
        <div className={`${styles["menu-content"]}`}>
          <img src={logoTelemont} alt="Logo Telemont" className={styles.logo} onClick={() => { navigate("/") }} />
          <div className={styles["mobile-menu-items"]}>
            <TextButton startIcon={planet} onClick={() => { navigate("/") }}
              sx={isHome ? { color: "var(--primary-blue)" } : { color: "var(--primary-white)" }}
            >
              pt
            </TextButton>
            <div className={styles["menu-burguer"]} onClick={switchOpenMenu}>
              {!open && <img src={menuBurguer} alt="Ícone de menu em barras" className={styles["menu-burguer"]} onClick={() => { }} />}
              {open && <img src={xTimes} alt="Ícone de fechar menu" className={styles["menu-burguer"]} onClick={() => { }} />}
            </div>
          </div>
        </div>
        <div
          className={`${styles["mobile-menu-buttons-list"]} ${open ? styles.open : ""}`}
        >
          <DefaultText sx={sxTextMenu}>
            A Empresa
          </DefaultText>
          <TextButton onClick={() => { navigate("/empresa/sobre-nos") }}
            sx={{ ...sxButtonMobileMenu, ...{ color: isHome ? "var(--primary-blue)" : "var(--primary-white)" } }}
          >
            Sobre Nós
          </TextButton>
          <TextButton onClick={() => { navigate("/empresa/pessoas") }}
            sx={{ ...sxButtonMobileMenu, ...{ color: isHome ? "var(--primary-blue)" : "var(--primary-white)" } }}
          >
            Pessoas
          </TextButton>
          <TextButton onClick={() => { navigate("/empresa/docs-politicas") }}
            sx={{ ...sxButtonMobileMenu, ...{ color: isHome ? "var(--primary-blue)" : "var(--primary-white)" } }}
          >
            Políticas
          </TextButton>
          <TextButton onClick={() => { navigate("/empresa/midia") }}
            sx={{ ...sxButtonMobileMenu, ...{ color: isHome ? "var(--primary-blue)" : "var(--primary-white)" } }}
          >
            Mídia
          </TextButton>

          <DefaultText sx={sxTextMenu}>
            Serviços
          </DefaultText>
          <TextButton onClick={() => { navigate("/servicos/telecom") }}
            sx={{ ...sxButtonMobileMenu, ...{ color: isHome ? "var(--primary-blue)" : "var(--primary-white)" } }}
          >
            Telecom
          </TextButton>
          <TextButton onClick={() => { navigate("/servicos/energia") }}
            sx={{ ...sxButtonMobileMenu, ...{ color: isHome ? "var(--primary-blue)" : "var(--primary-white)" } }}
          >
            Energia
          </TextButton>
          <DefaultText onClick={() => { window.open('https://telemont.gupy.io/', '_blank'); }} sx={sxTextMenu}>
            Trabalhe Conosco
          </DefaultText>
          <DefaultText onClick={() => { navigate("/contato") }} sx={sxTextMenu} size="xs">
            Contato
          </DefaultText>
          <DefaultText sx={{ color: isHome ? "var(--primary-blue)" : "var(--primary-white)", fontFamily: "Montserrat-Bold" }} size="xs">
            Redes Telemont
          </DefaultText>
          <div className={styles["media-items"]}>
            <img src={linkedin} alt="Ícone LinkedIm" className={styles["media-icon"]} onClick={() => { redirectToMedia("linkedin") }} />
            <img src={youtube} alt="Ícone Youtube" className={styles["media-icon"]} onClick={() => { redirectToMedia("youtube") }} />
            <img src={instagram} alt="Ícone Instagram" className={styles["media-icon"]} onClick={() => { redirectToMedia("instagram") }} />
          </div>
        </div>
      </nav>
    </header>
  );
};

export default MobileMenu;
